/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetMiscWorldtime } from "../../funcs/miscGetMiscWorldtime.js";
import { GetMiscWorldtimeRequest$zodSchema } from "../../models/getmiscworldtimeop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetMiscWorldtimeRequest$zodSchema,
};

export const tool$miscGetMiscWorldtime: ToolDefinition<typeof args> = {
  name: "misc-get-misc-worldtime",
  description: `查询世界时间

需要和国外的朋友开会，想知道他那边现在几点？用这个接口一查便知。

## 功能概述
根据标准的时区名称（例如 'Asia/Shanghai' 或 'Europe/London'），获取该时区的当前准确时间、UTC偏移量、星期等信息。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetMiscWorldtime(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
